import React from 'react';
import { motion } from 'framer-motion';
import { FlickerGrid } from '../components/ui/FlickerGrid';
import { PlusButton } from '../components/ui/PlusButton';
import { upcomingPages } from '../data/upcomingPages';
import { UpcomingSlug } from '../types/content';
interface ComingSoonProps {
  slug: UpcomingSlug;
}
export function ComingSoon({
  slug
}: ComingSoonProps) {
  const page = upcomingPages.find(p => p.slug === slug) ?? upcomingPages[0];
  return <main className="bg-canvas pt-[72px]" data-id="element-350" data-mp="d8vz64ke5r8y">
      <section className="relative overflow-hidden bg-night text-white" data-id="element-351" data-mp="9agbrzkeegv0">
        <FlickerGrid data-id="element-352" data-mp="n0s7e8g6yxqw" />
        <div className="shell relative py-24 md:py-36" data-id="element-353" data-mp="n1bip6bc6nvy">
          <motion.p initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25
        }} className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 text-sm" data-id="element-354" data-mp="n2w9qlyfzop2">
            <span className="h-2 w-2 animate-blink bg-ember" aria-hidden data-id="element-355" data-mp="s17jyxsng17t" />
            Page en cours de fabrication
          </motion.p>
          <motion.h1 initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-6 max-w-4xl text-[clamp(44px,7vw,104px)] font-medium leading-[0.92] tracking-[-0.045em]" data-id="element-356" data-mp="x8315zphbjac">
            {page.title}
          </motion.h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-357" data-mp="1g3t0ff6121kj">{page.lead}</p>
          <div className="mt-10 flex flex-wrap gap-3" data-id="element-358" data-mp="1l2xbycgfcbe1">
            <PlusButton to="/#contact" data-id="element-359" data-mp="1l1mbali9zjr5">Demander un devis</PlusButton>
            <PlusButton to="/" variant="outline" data-id="element-360" data-mp="1pv76k5shhzmn">
              Retour à l’accueil
            </PlusButton>
          </div>
        </div>
      </section>

      <section className="shell grid gap-10 py-20 md:py-28 lg:grid-cols-12" data-id="element-361" data-mp="1yvvnb899ie38">
        <h2 className="text-3xl font-medium tracking-[-0.03em] lg:col-span-4" data-id="element-362" data-mp="23ugcmcmz7dcw">Au programme de cette page</h2>
        <ul className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-363" data-mp="3rxnjwgjao31">
          {page.sections.map(s => <li key={s} className="flex gap-4 py-5 text-lg" data-id="element-364" data-mp="3uz9uzjrm7n5r">
              <span className="mt-[11px] h-2 w-2 shrink-0 bg-ember" aria-hidden data-id="element-365" data-mp="3uwnn1j0tb5n0" />
              {s}
            </li>)}
        </ul>
      </section>
    </main>;
}